import React, { PureComponent } from 'react';

 
class Construction extends PureComponent {
    render() {
      return(
        <div>
          <img alt='' src="https://memberpress.com/wp-content/uploads/2020/12/coming-soon-page.jpg"/>
        </div>
        
      )
      
    }

}



export default Construction;